import React 
  from 'react';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';

const data01 = [
{ name: '50000000', value: 203 },
{ name: '45000000', value: 130 },
{ name: '71000000', value: 18 },
{ name: '42000000', value: 16 },
];
const data02 = [
{ name: '50100000', value: 115 },
{ name: '50200000', value: 43 },
];

const RADIAN = Math.PI / 180;
interface LabelProps {
  cx: number;
  cy: number;
  value: number;
  midAngle: number;
  innerRadius: number;
  outerRadius: number;
  percent: number;
  index: number;
  name: string;
}

const renderCustomizedLabel = ({ 
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    value,
    name,
    index,
}: LabelProps) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${value} 
        (${(percent * 100).toFixed(0)}%)
    `}
    </text>
  );
};

export const FocusMultilayerPiechart: React.FC = () => {
return (<>
        <PieChart width={800} height={800}>
            <Pie 
                data={data01} 
                dataKey="value" 
                cx="50%" cy="50%" 
                outerRadius={200} 
                fill="#8884d8" 
                label={renderCustomizedLabel}
                labelLine={false}
            />
          <Pie data={data02} dataKey="value" cx="50%" cy="50%" innerRadius={250} outerRadius={300} fill="#82ca9d" label />
        </PieChart>
      </>
    );
}